module.exports = __webpack_public_path__ + "img/export-csv.758dfd41.svg";